export default {
  SERVER_ERROR: 'BaseErrorWindow.reloadingMessage',
  NETWORK_ERROR: 'BaseErrorWindow.networkError',
};
